import { render, staticRenderFns } from "./_promotionSignupOngoing.vue?vue&type=template&id=19c53c92&scoped=true&lang=pug"
import script from "./_promotionSignupOngoing.vue?vue&type=script&lang=js"
export * from "./_promotionSignupOngoing.vue?vue&type=script&lang=js"
import style0 from "./_promotionSignupOngoing.vue?vue&type=style&index=0&id=19c53c92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c53c92",
  null
  
)

export default component.exports